import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// constants
import { DashboarPageActionTypes } from './constants';
import { SagaIterator } from 'redux-saga';
import { changeChartLayoutAction, changeChartsAction, changeChartsLoadAction, changeFilterMenuListAction, changeFilterMenuListGetLoadAction } from './actions';
import { APICore } from '../../helpers/api/apiCore';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import { changeDashboardChartsAction } from '../dashboardPageData/actions';
import { isUndefined } from 'lodash';

const api = new APICore();


/**
 * Toggle the class on body
 * @param {*} cssClass
 */


/**
 * ---------------------------------------------------------------------------------------------------------------------------
 * Note: Following are the functions which allows you to save the user prefrences on backend side by making an api request.
 * For now, we are just applying the required logic on frontend side
 * ----------------------------------------------------------------------------------------------------------------------------
 */

/**
 * Show the rightsidebar
 */

const getAddFilterRequestAsync = async (item: any) => {
  try {
    const { data } = await api.create(API_ENDPOINTS.FILTERMENU, item);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}


const getEditFilterRequestAsync = async (item: any) => {
  try {
    const { data } = await api.update(API_ENDPOINTS.FILTERMENU, item);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}




const getDeleteFilterRequestAsync = async (itemId: any) => {
  try {

    const data = await api.delete(`${API_ENDPOINTS.FILTERMENU}/${itemId}`);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}
const getCopyChartRequestAsync = async (item: any) => {
  try {
    const { data } = await api.create(API_ENDPOINTS.CHART_CREATE, item);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}

const getViewChartRequestAsync = async (item: any) => {
  try {
    const { data } = await api.update(API_ENDPOINTS.CHARTMENUPAGE_UPDATECHARTFROMPAGE, item);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}



const getUpdateChartFromPageRequestAsync = async (item: any) => {
  try {
    const { data } = await api.update(API_ENDPOINTS.CHARTMENUPAGE_UPDATECHARTFROMPAGE, item);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}

const getDeleteChartFromPageRequestAsync = async (item: any) => {
  try {
    const { data } = await api.create(API_ENDPOINTS.CHARTMENUPAGE_DELETECHARTFROMPAGE, item);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}





const getFilterListRequestAsync = async (Id: any) => {
  try {
    let url: string = "";

    url = `${API_ENDPOINTS.FILTERMENU_PAGE}/${Id}`;


    const { data } = await api.get(url, null);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}

const getPublicFilterListRequestAsync = async (item: any) => {
  try {
    let url: string = "";
    //const encodeData = encodeURIComponent(item.encryptedString)
    url = `${API_ENDPOINTS.SHARELINK_MENUPAGE}/${item.id}?data=${item.encryptedString}`;


    const { data } = await api.get(url, null);
    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}

const getPublicShareChartListRequestAsync = async (item: any) => {
  try {
    let url: string = "";
    //const encodeData = encodeURIComponent(item.encryptedString)
    //url = `${API_ENDPOINTS.PUBLIC_PAGE}/${item.id}?data=${encodeData}`;

    const { data } = await api.create(API_ENDPOINTS.SHARELINK_PAGE, item);
    if (data.data)
      return data.data
    {
      if (data.statusCode === 'UnAuthorized')
        return { "message": { title: 'UnAuthorized', message: '' } }
      else
        if (data.statusCode === 'ExpireTimeLink')
          return { "message": { title: 'ExpireTimeLink', message: data?.message } }
        else
          return data
    }
  }
  catch (e) {
    return { "message": e }
  };
}

const getLandingChartListRequestAsync = async (p: any) => {
  try {
    let url: string = "";

    url = `${API_ENDPOINTS.CHARTMENUPAGE_LANDING}/${p?.locationId}/${p?.userId}`;

    const { data } = await api.get(url, null);
    if (data.data)
      return data.data
    else {
      if (data.statusCode === 'UnAuthorized')
        return { "message": { title: 'UnAuthorized', message: '' } }
      else
        if (data.statusCode === 'ExpireTimeLink')
          return { "message": { title: 'ExpireTimeLink', message: data?.message } }
        else
          return data
    }
  }
  catch (e) {
    return { "message": e }
  };
}

const getChartListRequestAsync = async (Id: any) => {
  try {
    let url: string = "";

    url = `${API_ENDPOINTS.CHARTMENUPAGE_PAGE}/${Id}`;


    const { data } = await api.get(url, null);
    if (data.data)
      return data.data
    else {
      if (data.statusCode === 'UnAuthorized')
        return { "message": { title: 'UnAuthorized', message: '' } }
      else
        if (data.statusCode === 'ExpireTimeLink')
          return { "message": { title: 'ExpireTimeLink', message: data?.message } }
        else
          return data
    }
  }
  catch (e) {
    return { "message": e }
  };
}

const getCurrentUserSecurityRequestAsync = async () => {
  try {
    let url: string = "";
    if (api.isUserAuthenticated()) {
      url = API_ENDPOINTS.CurrentUserSecurity;

      const { data } = await api.get(url, null);
      if (data.data)
        return data.data
      else
        if (data.statusCode === 'UnAuthorized')
          return { "message": 'UnAuthorized' }
        //window.location.href = '/access-denied';

        else
          return data
    }
    else
      return []
  }
  catch (e) {
    return { "message": e }
  };
}


function* getCopyChart({ payload }: any): SagaIterator {
  try {
    const dd = yield call(getCopyChartRequestAsync, payload.item);
    const response = yield call(getChartListRequestAsync, payload.pageId);
    const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);

    yield put(changeChartsAction({ data: response, userSecurity: responseSecurity, breakPoint: payload?.breakPoint }));
    //yield put(changeDashboardChartsAction(response));      
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getViewChart({ payload }: any): SagaIterator {
  try {
    yield call(getViewChartRequestAsync, payload.item);
    const response = yield call(getChartListRequestAsync, payload.item.sMenuPageId);
    const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);

    yield put(changeChartsAction({ data: response, userSecurity: responseSecurity,breakPoint: payload?.breakPoint }));
    //yield put(changeDashboardChartsAction(response));      
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getDeleteChartFromPage({ payload }: any): SagaIterator {
  try {
    yield call(getDeleteChartFromPageRequestAsync, payload);
    const response = yield call(getChartListRequestAsync, payload.sMenuPageId);
    const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);

    yield put(changeChartsAction({ data: response, userSecurity: responseSecurity, breakPoint: payload?.breakPoint }));
    //yield put(changeDashboardChartsAction(response));      
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getUpdateChartFromPage({ payload }: any): SagaIterator {
  try {
    yield call(getUpdateChartFromPageRequestAsync, payload);
    const response = yield call(getChartListRequestAsync, payload.sMenuPageId);
    const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);

    yield put(changeChartsAction({ data: response, userSecurity: responseSecurity }));
    //دو خط زیر کامنت شد تا هنگام جابجایی نمودارها در صفحه نمودارها رفرش نشوند
    //const response = yield call(getChartListRequestAsync,payload.sMenuPageId);
    //yield put(changeChartsAction(response));
    //yield put(changeChartLayoutAction(response));

  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getUpdateLayoutFromPage({ payload }: any): SagaIterator {
  try {

    // اگر payload فقط breakpoint است، کاری نکن
    if (typeof payload === 'string') {
      return;
    }

    // اگر payload یک آبجکت است، دیتا را refresh کن
    if (payload && payload.sMenuPageId) {
      const response = yield call(getChartListRequestAsync, payload.sMenuPageId);
      const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);

      // اطمینان حاصل کن که payload کامل است
      yield put(changeChartsAction({
        data: response,
        userSecurity: responseSecurity,
        sMenuPageId: payload.sMenuPageId  // این خط مهم است
      }));
    }
  } catch (error) {
    console.error('getUpdateLayoutFromPage error', error);
  }
}

// function* getUpdateLayoutFromPage({ payload }: any): SagaIterator {
//   try {
//     //const response = yield call(getUpdateChartFromPageRequestAsync, payload);

//     //دو خط زیر کامنت شد تا هنگام جابجایی نمودارها در صفحه نمودارها رفرش نشوند
//     const response = yield call(getChartListRequestAsync,payload.sMenuPageId);
//     yield put(changeChartsAction(response));
//     //yield put(changeChartLayoutAction(response));

//   } catch (error) {
//     //yield put(getRadiobuttonListError(error));
//   }
// }

// function* getUpdateLayoutFromPage({ payload }: any): SagaIterator {
//   try {
//     // اگر payload فقط یک رشته (مثلاً 'lg','md','sm','xs') است، این action صرفاً برای تغییر breakpoint است
//     // و نیازی به فراخوانی سرور / بازنویسی layout نیست.
//     if (typeof payload === 'string') {
//       // در صورت نیاز می تونی اینجا لاگ بزنی یا کاری انجام بدی
//       return;
//     }

//     // اگر payload یک آبجکت با sMenuPageId باشد، آنگاه fetch کن و layout ها را بروز کن
//     if (payload && payload.sMenuPageId) {
//       const response = yield call(getChartListRequestAsync, payload.sMenuPageId);
//       yield put(changeChartsAction(response));
//     }
//   } catch (error) {
//     // مدیریت خطا (هم‌اکنون خاموش شده، در صورت نیاز لاگ یا put error انجام بده)
//     // yield put(getRadiobuttonListError(error));
//     console.error('getUpdateLayoutFromPage error', error);
//   }
// }



function* getAddFilter({ payload }: any): SagaIterator {
  try {
    yield call(getAddFilterRequestAsync, payload.item);
    const response = yield call(getFilterListRequestAsync, payload.pageId);
    yield put(changeFilterMenuListAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getEditFilter({ payload }: any): SagaIterator {
  try {
    yield call(getEditFilterRequestAsync, payload.item);
    const response = yield call(getFilterListRequestAsync, payload.pageId);
    yield put(changeFilterMenuListAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getDeleteFilter({ payload }: any): SagaIterator {
  try {
    yield call(getDeleteFilterRequestAsync, payload.item);
    const response = yield call(getFilterListRequestAsync, payload.pageId);
    yield put(changeFilterMenuListAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}





function* getFilterListItems({ payload }: any): SagaIterator {
  try {

    yield put(changeFilterMenuListGetLoadAction());
    const response = yield call(getFilterListRequestAsync, payload);
    yield put(changeFilterMenuListAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getPublicFilterListItems({ payload }: any): SagaIterator {
  try {
    yield put(changeFilterMenuListGetLoadAction());
    const response = yield call(getPublicFilterListRequestAsync, payload);
    yield put(changeFilterMenuListAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getChartListItems({ payload }: any): SagaIterator {
  try {
    yield put(changeChartsLoadAction());
    if (api.isUserAuthenticated() !== false) {
      const response = yield call(getChartListRequestAsync, payload.locationId);
      const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);
      yield put(changeChartsAction({ data: response, userSecurity: responseSecurity, breakPoint: payload?.breakPoint }));
    }
    //yield put(changeDashboardChartsAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getLandingChartListItems({ payload }: any): SagaIterator {
  try {
    yield put(changeChartsLoadAction());
    
      const response = yield call(getLandingChartListRequestAsync, payload);
      yield put(changeChartsAction({ data: response, userSecurity: [], breakPoint: payload?.breakPoint }));
    
    //yield put(changeDashboardChartsAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

function* getPublicShareChartListItems({ payload }: any): SagaIterator {
  try {
    //yield put(changeChartsLoadAction());
    const response = yield call(getPublicShareChartListRequestAsync, { id: payload?.id, encryptedString: payload?.encryptedString });
    //const responseSecurity = yield call(getCurrentUserSecurityRequestAsync);        
    yield put(changeChartsAction({ data: response, userSecurity: [], breakPoint: payload?.breakPoint }));
    //yield put(changeDashboardChartsAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

/**
 * Hides the rightsidebar
 */



export function* watchCopyChart(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_CHARTS_COPY, getCopyChart);
}

export function* watchViewChart(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_CHARTS_VIEW, getViewChart);
}

export function* watchDeleteChartFromPage(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_CHARTS_DELETE_FROMPAGE, getDeleteChartFromPage);
}

export function* watchUpdateChartFromPage(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_CHARTS_UPDATE_FROMPAGE, getUpdateChartFromPage);
}

export function* watchUpdateLayoutFromPage(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_LAYOUT_UPDATE_FROMPAGE, getUpdateLayoutFromPage);
}




export function* watchAddFilter(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_FILTERMENU_ADD, getAddFilter);
}

export function* watchEditFilter(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_FILTERMENU_EDIT, getEditFilter);
}

export function* watchDeleteFilter(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_FILTERMENU_DELETE, getDeleteFilter);
}



export function* watchGetList(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_CHARTS_GET, getChartListItems);
}

export function* watchPublicShareGetList(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_PUBLICSHARE_CHARTS_GET, getPublicShareChartListItems);
}

export function* watchLandingGetList(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_LANDING_CHARTS_GET, getLandingChartListItems);
}



export function* watchGetFilterList(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_FILTERMENULIST_GET, getFilterListItems);
}

export function* watchGetPublicFilterList(): any {
  yield takeEvery(DashboarPageActionTypes.CHANGE_PUBLICFILTERMENULIST_GET, getPublicFilterListItems);
}





function* DashbordPageSaga(): any {
  yield all([fork(watchGetList), fork(watchPublicShareGetList),fork(watchLandingGetList), fork(watchCopyChart), fork(watchViewChart), fork(watchDeleteChartFromPage),
  fork(watchGetFilterList), fork(watchGetPublicFilterList), fork(watchAddFilter), fork(watchEditFilter), fork(watchDeleteFilter), fork(watchUpdateChartFromPage)]);
}

export default DashbordPageSaga;
